<div id="app_container" [class.is-mobile]="mobileQuery.matches" [ngClass]="printing ? '' : 'nav-container'">

  @if (!printing) {
    <mat-toolbar color="primary" class="app-toolbar">
      <button mat-icon-button (click)="toggleNavigation()"><mat-icon>menu</mat-icon></button>
      <h1 class="app-name"><a routerLink="/">{{appTitle}}</a></h1>
      <span class="flex-auto"></span>
      <app-theme-picker tooltip="{{'function.Theme' | translate}}"></app-theme-picker>
      @if (!isUserLoggedIn) {
        <button mat-button (click)="router.navigateByUrl('/login')">
          <mat-icon>lock_open</mat-icon>
          <span>{{'function.Login' | translate}}</span>
        </button>
      }
      @if (isUserLoggedIn) {
        <button class="side-button" mat-button [matMenuTriggerFor]="accountMenu" matTooltip="{{'function.UserAccount' | translate}}">
          <mat-icon class="menu-button">account_circle</mat-icon>
          <span class="hide-xs">{{'function.Account' | translate}}</span>
        </button>
      }
      <mat-menu #accountMenu="matMenu">
        <button mat-menu-item (click)="router.navigateByUrl('/settings')">
          <mat-icon>person</mat-icon><span>{{'function.Profile' | translate}}</span>
        </button>
        <button mat-menu-item (click)="logout()">
          <mat-icon>lock</mat-icon><span>{{'function.Logout' | translate}}</span>
        </button>
      </mat-menu>
    </mat-toolbar>
  }

  <mat-sidenav-container class="app-sidenav-container app-sidenav-container-print"
    [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    @if (!printing) {
      <mat-sidenav #mainNav class="app-sidenav-nav" [mode]="mobileQuery.matches ? 'over' : 'side'"
        [fixedInViewport]="mobileQuery.matches" fixedTopGap="56" [opened]="!mobileQuery.matches">
        @if (isUserLoggedIn) {
          <mat-nav-list >
            @for (uiFunction of uiFunctions; track uiFunction) {
              <span>
                @if (!uiFunction.isFolder && hasAccessToFunction(uiFunction)) {
                  <a mat-list-item routerLinkActive="active" [fragment]="uiFunction.fragment ? uiFunction.fragment : null" routerLink="{{ uiFunction.route }}" [routerLinkActiveOptions]="{ exact: uiFunction.route == '' }"><mat-icon matListItemIcon>{{ uiFunction.icon }}</mat-icon>{{ getFunctionTitle(uiFunction) }}</a>
                }
                @if (uiFunction.isFolder && hasAccessToFunction(uiFunction)) {
                  <mat-expansion-panel #admin [class.mat-elevation-z0]="!admin.expanded">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <mat-icon>{{ uiFunction.icon }}</mat-icon>{{ getFunctionTitle(uiFunction) }}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    @for (childUiFunction of uiFunction.childUiFunctions; track childUiFunction) {
                      <span>
                        @if (hasAccessToFunction(childUiFunction)) {
                          <a mat-list-item routerLinkActive="active" fragment="{{ childUiFunction.fragment }}" routerLink="{{ childUiFunction.route }}"><mat-icon matListItemIcon>{{ childUiFunction.icon }}</mat-icon>{{ getFunctionTitle(childUiFunction) }}</a>
                        }
                      </span>
                    }
                  </mat-expansion-panel>
                }
              </span>
            }
          </mat-nav-list>
        }
      </mat-sidenav>
    }

    <mat-sidenav-content>
      <div class="flex-col fill">
        <div id="mainContent" class="flex-auto">
          <router-outlet></router-outlet>
        </div>
      <!--app-footer></app-footer-->
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
</div>

@if (!printing) {
  <ngx-toasta></ngx-toasta>
}
